module.exports = __webpack_public_path__ + "media/images/banner/1-c5f04bd88879ef7a90258795e5403e22.jpg";